import { Injectable, ViewChild, Directive } from '@angular/core';
import { MeterWritingErrorCodes } from '@app/shared/models/meter-data/meter-reading';
import { BehaviorSubject, of, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { MeterTypesService } from '@app/shared/services/api/meter-types.service';
import { isNil, isEmpty } from 'lodash';
import { MatSort } from '@angular/material/sort';
import { MeterTypes } from '@app/shared/models/meter-types';
import { EnergyTypes } from '@app/shared/models/energy-types';
import { EnergyTypesService } from '@app/shared/services/api/energy-types.service';
import { tap } from 'rxjs/operators';

@Directive()
@Injectable({
  providedIn: 'root',
})
export class MeterDataStoreServiceDirective {
  @ViewChild(MatSort, { static: true }) sort: MatSort = new MatSort();
  public searchParamMeterData = '';
  private store: {
    meterWritingErrorCodes: MeterWritingErrorCodes;
    meterTypes: MeterTypes[];
    energyTypes: EnergyTypes[];
    uploadedMeterReadings: any;
  } = {
    meterWritingErrorCodes: {},
    meterTypes: [],
    energyTypes: [],
    uploadedMeterReadings: [],
  };

  constructor(private energyTypesService: EnergyTypesService, private meterTypesService: MeterTypesService, private translate: TranslateService) {}

  private _uploadedmeterReadings$ = new BehaviorSubject<any[] | null>(null);

  public get uploadedMeterReadings$(): BehaviorSubject<any> {
    return this._uploadedmeterReadings$;
  }

  public updateMeterReadings(value: any): void {
    this.store.uploadedMeterReadings = value;
    this._uploadedmeterReadings$.next(value);
  }

  public get meterWritingErrorCodes(): MeterWritingErrorCodes {
    return this.store.meterWritingErrorCodes;
  }

  public getMeterTypeImage(code?: string, deviceEUI?: string): string {
    if (!isNil(deviceEUI)) {
      return 'remote_merged';
    }
    if (isNil(code)) {
      return '';
    }
    const meterType = this.store.meterTypes.find((data) => data.code === code);
    if (isNil(meterType)) {
      return '';
    }
    return meterType.imageName;
  }

  public getEnergyTypeImage(name?: string): string {
    if (isNil(name)) {
      return '';
    }
    const energyType = this.store.energyTypes.find((data) => data.name === name);
    if (isNil(energyType)) {
      return '';
    }
    return energyType.imageName;
  }

  public preloadReferences(): void {
    this.getMeterTypes().subscribe();
    this.getEnergyTypes().subscribe();
  }

  public getMeterTypes(): Observable<MeterTypes[]> {
    return !isEmpty(this.store.meterTypes)
      ? of(this.store.meterTypes)
      : this.meterTypesService.getAllActive().pipe(tap((response: MeterTypes[]) => (this.store.meterTypes = response)));
  }

  public getEnergyTypes(): Observable<EnergyTypes[]> {
    return !isEmpty(this.store.energyTypes)
      ? of(this.store.energyTypes)
      : this.energyTypesService.getAllActive().pipe(tap((response: EnergyTypes[]) => (this.store.energyTypes = response)));
  }
}
